import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlayCircle, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export const VideoCarousel = ({ heading = "Explore life in Mexico", compact = false }) => {
  const [videos, setVideos] = useState([]);
  useEffect(() => {
    api.get("/videos", { params: { featured: true } }).then((r) => setVideos(r.data.slice(0, 3))).catch(() => {});
  }, []);
  if (videos.length === 0) return null;
  return (
    <section data-testid="video-carousel" className={compact ? "" : "mx-auto max-w-7xl px-6 lg:px-12 py-16 lg:py-20"}>
      <div className="flex items-end justify-between gap-4 mb-6">
        <h2 className={compact ? "flex items-center gap-2 font-serif text-xl text-charcoal-800" : "text-3xl sm:text-4xl font-normal text-charcoal-800"}>
          {compact && <PlayCircle size={18} className="text-terracotta" />}{heading}
        </h2>
        <Link to="/life-in-mexico" data-testid="video-carousel-all" className="inline-flex items-center gap-1 text-sm font-medium text-terracotta hover:underline shrink-0">
          All videos <ArrowRight size={14} />
        </Link>
      </div>
      <div className="grid gap-5 sm:grid-cols-3">
        {videos.map((v) => (
          <Link key={v.id} to={`/life-in-mexico/${v.slug}`} data-testid={`video-card-${v.slug}`}
            className="group overflow-hidden rounded-2xl border border-sand-200 bg-white hover:border-terracotta transition-colors">
            <div className="relative aspect-video overflow-hidden bg-sand-200">
              {v.thumbnail && <img src={v.thumbnail} alt={v.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />}
              <span className="absolute inset-0 flex items-center justify-center">
                <PlayCircle size={44} className="text-white drop-shadow-lg opacity-90" strokeWidth={1.2} />
              </span>
              {v.tag && <span className="absolute left-3 top-3 rounded-full bg-white/90 px-2.5 py-0.5 text-[11px] font-medium text-charcoal-700">{v.tag}</span>}
            </div>
            <div className="p-4">
              <p className="text-sm font-medium text-charcoal-800 group-hover:text-terracotta transition-colors">{v.title}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
